import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators
} from '@angular/forms';

import { CreateField } from './../../../models/custom-fields/create-field.model';
import { FieldType } from './../../../models/custom-fields/filed-type.model';
import { EntityType } from './../../../models/custom-fields/entity-type.enum';

import { CustomFieldService } from 'api-services/custom-field.service';
import { SharedService } from '../../../services';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';
import { ngbModalOptions } from 'shared/constant';
import { AlertService } from '../alert-dialog/alert.service';

@Component({
  selector: 'app-add-custom-fields',
  templateUrl: './add-custom-fields.component.html',
  styleUrls: ['./add-custom-fields.component.css']
})
export class AddCustomFieldsComponent implements OnInit {
  @Input() customFieldDetail;
  @Input() entityType;
  @Input() fieldId: number = 0;
  @Input() EditView: boolean = false;
  @Output() cancelEdit: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Input() isArchived: boolean = false;
  @Input() fieldCount: number = 0;
  addCustomFieldForm: FormGroup;
  fieldTypeList: FieldType[] = [];
  @Output() fieldCreated = new EventEmitter<void>();
  options: any[] = [];
  fieldDetail: CreateField = {} as CreateField;

  constructor(private customFieldService: CustomFieldService,
    private shareService: SharedService,
    private sharedService: SharedService,
    private alertService: AlertService,
    private modalService: NgbModal) { }

  ngOnInit(): void {
    this.getFieldTypes();
    this.addCustomFieldForm = this.bindaddCustomFieldForm();
   
    if (this.fieldId) {

      this.loadField();

    }
  }

  getFieldTypes() {
    this.customFieldService.getFieldTypes().subscribe
      ((res) => {
        this.fieldTypeList = res;
      });
  }

  bindaddCustomFieldForm(): FormGroup{
    return new FormGroup({

      fieldId: new FormControl(0),

      fieldTypeId: new FormControl(null, Validators.required),

      label: new FormControl(null, Validators.required),

      placeholder: new FormControl(null),

      defaultValue: new FormControl(null),

      isRequired: new FormControl(false),

      ordinalPosition: new FormControl(1),

      value: new FormControl(null)

    });
  }

  get isDropdown(): boolean {

    const item = this.fieldTypeList.find(x =>
      x.fieldTypeId ==
      this.addCustomFieldForm.value.fieldTypeId);

    return item?.name === 'Dropdown';

  }

  get showPlaceholder(): boolean {

    const item = this.fieldTypeList.find(x =>
      x.fieldTypeId ==
      this.addCustomFieldForm.value.fieldTypeId);

    if (!item)
      return false;

    return item.name == 'Textbox'
      || item.name == 'Amount'
      || item.name == 'TextArea';

  }

   addUpdateField() {
    const request: CreateField = {
      label: this.addCustomFieldForm.value.label,
      fieldTypeId: this.addCustomFieldForm.value.fieldTypeId,
      placeholder: this.addCustomFieldForm.value.placeholder,
      defaultValue: this.addCustomFieldForm.value.defaultValue,
      isRequired: this.addCustomFieldForm.value.isRequired,
      ordinalPosition: this.addCustomFieldForm.value.ordinalPosition,
      items: this.options.length
        ? JSON.stringify(this.options)
        : null,
      value: this.addCustomFieldForm.value.value,
      entityType: this.entityType

    };

     if (this.fieldId) {
       request.fieldId = this.fieldId;

      this.customFieldService
        .updateField(request)
        .subscribe(
          (response: any) => {
            this.sharedService.showToastMessage('Custom field updated successfully.');
            this.resetForm();
            this.fieldCreated.emit();
          },
          (error: any) => {
            console.log(error);
            this.alertService.warn(error.message);
          }
        );
    }
    else {
      this.customFieldService
        .createField(request)
        .subscribe(
          (response: any) => {
            this.sharedService.showToastMessage('Custom field created successfully.');
            this.resetForm();
            this.fieldCreated.emit();
          },
          (error: any) => {
            console.log(error);
            this.alertService.warn(error.message);
          }
        );
    }
  }

  cancel(){
    this.cancelEdit.next(false);
  }

  
  onFieldTypeChange(): void {

    const fieldTypeId = this.addCustomFieldForm.get('fieldTypeId')?.value;

    const selectedField = this.fieldTypeList.find(
      x => x.fieldTypeId === fieldTypeId
    );

    this.options = [];
    

    if (!selectedField) {
      return;
    }

    if(selectedField.name == 'Textbox' || selectedField.name == 'Amount' || selectedField.name == 'TextArea'){
        this.addCustomFieldForm.get('placeholder')!.setValidators(Validators.required);
      }else{
        this.addCustomFieldForm.get('placeholder')!.clearValidators();
        this.addCustomFieldForm.get('placeholder')!.setValue(null);
    }

    switch (selectedField.name) {

      case 'Dropdown':
      case 'Radio':
      case 'MultiSelect':

        this.addOption();
        break;

    }

  }

  addOption(){
    const nextId = this.options.length ? this.options[this.options.length - 1].id + 1 : 1;

    this.options.push({

      id: nextId,

      text: '',

      value: '',

      placeholder: `Option ${nextId}`

    });
    setTimeout(() => {
      const newlyCreatedInput = document.getElementById(`input-${nextId}`) as HTMLInputElement;
      
      if (newlyCreatedInput) {
        newlyCreatedInput.focus();
      }
    }, 0);
 }

  clearOption(id){
     this.options = this.options.filter(x => x.id !== id);
  }

  resetForm(): void {

    this.addCustomFieldForm.reset();

    this.addCustomFieldForm.patchValue({

      fieldId: 0,
      fieldTypeId: null,
      label: '',
      placeholder: '',
      defaultValue: '',
      isRequired: false,
      ordinalPosition: 1,
      value: ''

    });

    this.options = [];

    this.addCustomFieldForm.markAsPristine();
    this.addCustomFieldForm.markAsUntouched();


  }

  loadField(): void {

    this.customFieldService
      .getFieldById(this.fieldId)
      .subscribe(field => {
        this.fieldDetail = field;
        this.fieldDetail.createdOn = this.shareService.convertUTCTimeToLocalTime(this.fieldDetail.createdOn);
        this.fieldDetail.modifiedOn = this.shareService.convertUTCTimeToLocalTime(this.fieldDetail.modifiedOn);
        this.fieldDetail.archivedOn = this.shareService.convertUTCTimeToLocalTime(this.fieldDetail.archivedOn);
       
        this.addCustomFieldForm.patchValue(field);

        this.onFieldTypeChange();

        if (field?.items) {

          this.options = JSON.parse(field.items);

        }

      });

  }

   archiveCustomField(){
          var modalData = {
            title: "Archive Custom Field",
            prompt: `Are you sure you want archive custom field <strong>${this.fieldDetail.label}</strong>?`
          }
           const modalRef = this.modalService.open(ConfirmDialogComponent, ngbModalOptions);
              modalRef.componentInstance.modalData = modalData;
              modalRef.componentInstance.buttonText = 'Yes';
              modalRef.componentInstance.buttonClass = 'primary-btn';
              modalRef.componentInstance.buttonText1 = 'No';
          
          modalRef.result.then((data) => {
            if (data) {
  
              this.customFieldService.archiveField({
  
                fieldId: this.fieldId,
  
                archive: true
  
              }).subscribe(() => {
  
                this.fieldCreated.emit();
  
              });
  
            }
          })
    }
}
